import { createStackNavigator } from '@react-navigation/stack'
import * as React from 'react'
import { documentTitle } from '../../static/Routes'

const Stack = createStackNavigator()
const JioPayConsumers = React.lazy(() => import('../../screens/JioPayConsumers'))

export const JioPayForConsumersStack = () => {
  return (
    <Stack.Screen
      name={'jio-pay-consumers'}
      component={JioPayConsumers}
      options={{
        title: documentTitle.jiopayconsumers,
      }}
    />
  )
}
